/**
 * Registers various hooks for updating or modifying the UI elements in specific components such as
 * product grids, top-page options, and product swatches.
 *
 * The hooks manipulate DOM elements to enhance or customize the display and interaction
 * with product reviews, sorting options, and color swatches.
 *
 * The following hooks are registered:
 * - `serp-product-grid`: Enhances product grid items with additional review count and formatting for review averages.
 * - `serp-top-page`: Adds a 'Sort By' label to the sorting dropdown UI if it doesn't already exist.
 * - `serp-product-swatches`: Adds additional functionality and elements to color swatch UI based on the number of available color variations.
 *
 * @return {void} No return value. The function alters DOM elements directly.
 */
function hooks() {
  window.SerpOptions.registerHook("serp-product-grid", ({products, element}) => {

    for (const [productId, product] of Object.entries(products)) {
      if (product.hasOwnProperty('reviewCount') && product.reviewCount > 0) {

        let productElement = element.querySelector(`[data-product-id="${productId}"]`);
        if (productElement) {
          let reviewAvgEl = productElement.querySelector('.fs-reviews-avg');
          if (reviewAvgEl && !reviewAvgEl.innerText.includes('(')) {
            reviewAvgEl.innerHTML = `<span class="fs-reviews-avg-el">(${reviewAvgEl.innerText})</span>`;
          }
          let reviewCountEl = productElement.querySelector('.fs-reviews-count');
          if (reviewCountEl && !reviewCountEl.innerText.includes('reviews')) {
            reviewCountEl.innerText = reviewCountEl.innerText.replace('(', '').replace(')', '') + ' reviews';
          }
        }
      }
    }

  });

  window.SerpOptions.registerHook("serp-top-page", ({element}) => {
    setTimeout(() => {

      let wrapper = element.querySelector('.fs-select-wrapper');

      if (wrapper && !wrapper.querySelector('.fs-select-label')) {
        let label = document.createElement("div");
        label.classList.add('fs-select-label');
        label.innerText = 'Sort By:';
        wrapper.appendChild(label);
      }
    }, 250)
  });

  window.SerpOptions.registerHook("serp-product-swatches", ({colors, swatchClick, showMoreClick, element}) => {

    let listEl = element.querySelector('.color-swatches');

    if (colors.length > 6 && !listEl.querySelector('.color-swatch-extra-colors')) {
      let extraColorsLength = colors.length - 6;
      let extraColorsText = extraColorsLength === 1 ? 'color' : 'colors';
      let text = `+ ${extraColorsLength} ${extraColorsText}`;

      let link = element.closest('.product-card').querySelector('.title-container').getAttribute('href');

      let colorsCountEl = document.createElement("a");
      colorsCountEl.classList.add('color-swatch-extra-colors');
      colorsCountEl.innerText = text;
      colorsCountEl.setAttribute('href', link);
      colorsCountEl.setAttribute('tabindex', '0');
      colorsCountEl.setAttribute('role', 'button');
      colorsCountEl.setAttribute('aria-label', text);
      listEl.appendChild(colorsCountEl);
    }

      setTimeout(function() {
        if (colors.length === 1 && listEl.querySelectorAll('.color-swatch-container').length < 1) {

        let resultClass = '';
        let randomSwatchEl = element.closest('.searchResultsWrapper').querySelector('.color-swatch');

        if (randomSwatchEl) {
          randomSwatchEl.classList.forEach((className) => {
            if (className.indexOf('fs-result-page-') > -1) {
              resultClass = className;
            }
          });
        }

        let color = colors[0];
        let swatchContainer = document.createElement("span");
        swatchContainer.classList.add('color-swatch-container');
        swatchContainer.classList.add('fs-color-swatch-container');
        swatchContainer.setAttribute('tabindex', '0');
        swatchContainer.setAttribute('role', 'button');
        swatchContainer.setAttribute('aria-label', `; Variant: ${color.value}`);

        let colorHandle = color.value.toLowerCase().replace(/\s/g, '-');

        let swatchElement = document.createElement("span");
        swatchElement.classList.add('color-swatch');
        swatchElement.classList.add('fast-swatch-color-fallback');
        swatchElement.classList.add(`fast-swatch-color-${colorHandle}`);
        swatchElement.classList.add(`isp-product-color-swatch-${colorHandle}`);
        if (resultClass) {
          swatchElement.classList.add(resultClass);
        }
        swatchElement.setAttribute('data-disabled', 'false');
        swatchElement.setAttribute('style', '--swatch-width:25px;--swatch-height:25px');
        //swatchElement.setAttribute('title', color.value);
        swatchElement.addEventListener('click', swatchClick);

        swatchContainer.appendChild(swatchElement);
        listEl.appendChild(swatchContainer);
        }
      },1)

  });
}

// execution here
if (window.SerpOptions) {
  hooks();
} else {
  window.addEventListener('fast-serp-ready', function () {
    hooks();
  });
}